import type { Rastgele } from '@kurultay/kurallar'
import type { SavasDurumu, SavasBirimi } from './tipler.js'

/**
 * Hedeflenebilir düşman birimleri.
 * Ön saf ayaktayken arka saf korunur; safDeler saldırılar bu korumayı atlar
 * (Alp/Balta fırlatma, Akıncı/Delici Ok, Kargıcı/Cirit).
 */
export function gecerliHedefler(
  durum: SavasDurumu,
  saldiran: SavasBirimi,
  safDeler: boolean,
): SavasBirimi[] {
  const dusmanlar = durum.birimler.filter((b) => b.taraf !== saldiran.taraf && b.yasiyor)
  if (safDeler) return dusmanlar

  const onSaf = dusmanlar.filter((b) => b.saf === 'on')
  return onSaf.length > 0 ? onSaf : dusmanlar.filter((b) => b.saf === 'arka')
}

/** Geçerli hedefler arasından tohumlu rastgele biri. */
export function hedefSec(
  durum: SavasDurumu,
  saldiran: SavasBirimi,
  safDeler: boolean,
  r: Rastgele,
): SavasBirimi | null {
  const hedefler = gecerliHedefler(durum, saldiran, safDeler)
  if (hedefler.length === 0) return null
  return hedefler[r.tamsayi(0, hedefler.length - 1)] ?? null
}
